import { Card, Typography } from 'antd'
import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'

export interface StatDisplayContainerProps {
  isLoading?: boolean
  children: ReactNode
  title?: string
  icon?: ReactNode
}

const CardBodyContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 8px 0;
`

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  justify-content: space-between;
`

const TitleText = styled(Typography.Text)`
  flex: 1;
  min-width: 0;
`

const IconWrapper = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`

const STAT_DISPLAY_CONTAINER_STYLE: React.CSSProperties = {
  width: '100%',
  maxWidth: '240px',
  minHeight: '120px',
  transition: 'all 0.3s ease',
  cursor: 'default',
}

export const StatDisplayContainer: FC<StatDisplayContainerProps> = ({
  children,
  isLoading,
  title,
  icon,
}) => {
  const titleContent = icon ? (
    <TitleContainer>
      <TitleText ellipsis={{ tooltip: true }}>{title}</TitleText>
      <IconWrapper>{icon}</IconWrapper>
    </TitleContainer>
  ) : (
    title
  )

  return (
    <Card
      title={titleContent}
      style={STAT_DISPLAY_CONTAINER_STYLE}
      loading={isLoading}
      size='small'
      hoverable
      styles={{
        header: {
          paddingLeft: '16px',
          paddingRight: '16px',
          paddingTop: '12px',
          paddingBottom: '12px',
          minHeight: '48px',
          borderRadius: '8px 8px 0 0',
        },
        body: {
          padding: '16px 12px',
          borderRadius: '0 0 8px 8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '72px',
        },
      }}>
      <CardBodyContainer>{children}</CardBodyContainer>
    </Card>
  )
}
